import { getFileNameExcel } from "helpers/utils";
import { TYPE_REPORT } from "pages/ReportInvoiceError/helper/functionHelper";
import React from "react";
import ListExport from "./ListExport";

const ListExportInvoiceWareHousesAgency = props => {
  return (
    <ListExport
      typeReport={TYPE_REPORT.INVOICE_WAREHOUSES_AGENCY}
      fileNameExport={getFileNameExcel("DanhSachPXK_DaiLy")}
    />
  );
};

export default ListExportInvoiceWareHousesAgency;
